/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 2
 * API documentations version 2.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BranchRequest } from '../model';
// @ts-ignore
import { GetBnplOrders200Response } from '../model';
// @ts-ignore
import { GetBnplStatisticsForStaff200Response } from '../model';
// @ts-ignore
import { GetBranchList200Response } from '../model';
// @ts-ignore
import { GetStaffInvitationList200Response } from '../model';
// @ts-ignore
import { GetStaffList200Response } from '../model';
// @ts-ignore
import { IntentRequest } from '../model';
// @ts-ignore
import { LodgingResult } from '../model';
// @ts-ignore
import { MarketBranch } from '../model';
// @ts-ignore
import { MarketStaff } from '../model';
// @ts-ignore
import { StaffRequest } from '../model';
// @ts-ignore
import { UploadDisbursementRequirementRequest } from '../model';
/**
 * DopApi - axios parameter creator
 * @export
 */
export const DopApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This for staff creates a new intent.
         * @summary Staff create intent
         * @param {IntentRequest} intentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntent: async (intentRequest: IntentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'intentRequest' is not null or undefined
            assertParamExists('createIntent', 'intentRequest', intentRequest)
            const localVarPath = `/v2/private/dop/intents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = intentRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This creates new market branch.
         * @summary Create branch
         * @param {BranchRequest} branchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMarketBranch: async (branchRequest: BranchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'branchRequest' is not null or undefined
            assertParamExists('createMarketBranch', 'branchRequest', branchRequest)
            const localVarPath = `/v2/private/dop/branches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = branchRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This disable the market branch.
         * @summary Disable branch
         * @param {string} branchId Branch ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableMarketBranch: async (branchId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'branchId' is not null or undefined
            assertParamExists('disableMarketBranch', 'branchId', branchId)
            const localVarPath = `/v2/private/dop/branches/{branch_id}/disable`
                .replace(`{${"branch_id"}}`, encodeURIComponent(String(branchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation disable a specified staff.
         * @summary Disable staff
         * @param {string} staffId Staff ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableStaff: async (staffId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'staffId' is not null or undefined
            assertParamExists('disableStaff', 'staffId', staffId)
            const localVarPath = `/v2/private/dop/staffs/{staff_id}/disable`
                .replace(`{${"staff_id"}}`, encodeURIComponent(String(staffId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This enable the market branch.
         * @summary Enable branch
         * @param {string} branchId Branch ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableMarketBranch: async (branchId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'branchId' is not null or undefined
            assertParamExists('enableMarketBranch', 'branchId', branchId)
            const localVarPath = `/v2/private/dop/branches/{branch_id}/enable`
                .replace(`{${"branch_id"}}`, encodeURIComponent(String(branchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation enable a specified staff.
         * @summary Enable staff
         * @param {string} staffId Staff ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableStaff: async (staffId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'staffId' is not null or undefined
            assertParamExists('enableStaff', 'staffId', staffId)
            const localVarPath = `/v2/private/dop/staffs/{staff_id}/enable`
                .replace(`{${"staff_id"}}`, encodeURIComponent(String(staffId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This retrieves bnpl transaction list for market staff. 
         * @summary BNPL transaction listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBnplOrders: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/private/dop/bnpl-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This retrieves BNPL statistics for staff 
         * @summary Get BNPL statistics for staff
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBnplStatisticsForStaff: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/private/dop/staff/bnpl-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This retrieve branch detail. 
         * @summary Get branch detail
         * @param {string} branchId Branch ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranchDetail: async (branchId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'branchId' is not null or undefined
            assertParamExists('getBranchDetail', 'branchId', branchId)
            const localVarPath = `/v2/private/dop/branches/{branch_id}`
                .replace(`{${"branch_id"}}`, encodeURIComponent(String(branchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This retrieves market branch list. 
         * @summary Get branch list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranchList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/private/dop/branches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This retrieves market branch list for staff 
         * @summary Get branch list for staff
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranchListForStaff: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/private/dop/staff/branches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This retrieves market staff detail for staff 
         * @summary Get staff detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailForStaff: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/private/dop/staff`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This retrieves staff invitation list. 
         * @summary Get staff invitation list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaffInvitationList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/private/dop/staff-invitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This retrieves market staff list. 
         * @summary Get staff list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaffList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/private/dop/staffs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This send a sms to staff that has a link confirmation.
         * @summary Send staff invitation
         * @param {StaffRequest} staffRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendStaffInvitation: async (staffRequest: StaffRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'staffRequest' is not null or undefined
            assertParamExists('sendStaffInvitation', 'staffRequest', staffRequest)
            const localVarPath = `/v2/private/dop/staff-invitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = staffRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This updates the market branch information.
         * @summary Update branch
         * @param {string} branchId Branch ID
         * @param {BranchRequest} branchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarketBranch: async (branchId: string, branchRequest: BranchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'branchId' is not null or undefined
            assertParamExists('updateMarketBranch', 'branchId', branchId)
            // verify required parameter 'branchRequest' is not null or undefined
            assertParamExists('updateMarketBranch', 'branchRequest', branchRequest)
            const localVarPath = `/v2/private/dop/branches/{branch_id}`
                .replace(`{${"branch_id"}}`, encodeURIComponent(String(branchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = branchRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload the document for BNPL order
         * @summary Upload BNPL order document
         * @param {string} orderId Order ID
         * @param {UploadDisbursementRequirementRequest} uploadDisbursementRequirementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBnplOrderDocument: async (orderId: string, uploadDisbursementRequirementRequest: UploadDisbursementRequirementRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('uploadBnplOrderDocument', 'orderId', orderId)
            // verify required parameter 'uploadDisbursementRequirementRequest' is not null or undefined
            assertParamExists('uploadBnplOrderDocument', 'uploadDisbursementRequirementRequest', uploadDisbursementRequirementRequest)
            const localVarPath = `/v2/private/dop/bnpl-orders/{order_id}/documents`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = uploadDisbursementRequirementRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This confirms an staff phone and code.
         * @summary Verify staff
         * @param {string} code Confirmation code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyStaff: async (code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('verifyStaff', 'code', code)
            const localVarPath = `/v2/private/dop/staff-invitations/{code}/accept`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DopApi - functional programming interface
 * @export
 */
export const DopApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DopApiAxiosParamCreator(configuration)
    return {
        /**
         * This for staff creates a new intent.
         * @summary Staff create intent
         * @param {IntentRequest} intentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIntent(intentRequest: IntentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LodgingResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIntent(intentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This creates new market branch.
         * @summary Create branch
         * @param {BranchRequest} branchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMarketBranch(branchRequest: BranchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketBranch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMarketBranch(branchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This disable the market branch.
         * @summary Disable branch
         * @param {string} branchId Branch ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableMarketBranch(branchId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableMarketBranch(branchId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation disable a specified staff.
         * @summary Disable staff
         * @param {string} staffId Staff ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableStaff(staffId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableStaff(staffId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This enable the market branch.
         * @summary Enable branch
         * @param {string} branchId Branch ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableMarketBranch(branchId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableMarketBranch(branchId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation enable a specified staff.
         * @summary Enable staff
         * @param {string} staffId Staff ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableStaff(staffId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableStaff(staffId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This retrieves bnpl transaction list for market staff. 
         * @summary BNPL transaction listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBnplOrders(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBnplOrders200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBnplOrders(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This retrieves BNPL statistics for staff 
         * @summary Get BNPL statistics for staff
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBnplStatisticsForStaff(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBnplStatisticsForStaff200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBnplStatisticsForStaff(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This retrieve branch detail. 
         * @summary Get branch detail
         * @param {string} branchId Branch ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBranchDetail(branchId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketBranch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBranchDetail(branchId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This retrieves market branch list. 
         * @summary Get branch list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBranchList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBranchList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBranchList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This retrieves market branch list for staff 
         * @summary Get branch list for staff
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBranchListForStaff(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBranchList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBranchListForStaff(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This retrieves market staff detail for staff 
         * @summary Get staff detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetailForStaff(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketStaff>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetailForStaff(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This retrieves staff invitation list. 
         * @summary Get staff invitation list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStaffInvitationList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStaffInvitationList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStaffInvitationList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This retrieves market staff list. 
         * @summary Get staff list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStaffList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStaffList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStaffList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This send a sms to staff that has a link confirmation.
         * @summary Send staff invitation
         * @param {StaffRequest} staffRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendStaffInvitation(staffRequest: StaffRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendStaffInvitation(staffRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This updates the market branch information.
         * @summary Update branch
         * @param {string} branchId Branch ID
         * @param {BranchRequest} branchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMarketBranch(branchId: string, branchRequest: BranchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketBranch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMarketBranch(branchId, branchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload the document for BNPL order
         * @summary Upload BNPL order document
         * @param {string} orderId Order ID
         * @param {UploadDisbursementRequirementRequest} uploadDisbursementRequirementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadBnplOrderDocument(orderId: string, uploadDisbursementRequirementRequest: UploadDisbursementRequirementRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadBnplOrderDocument(orderId, uploadDisbursementRequirementRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This confirms an staff phone and code.
         * @summary Verify staff
         * @param {string} code Confirmation code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyStaff(code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyStaff(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DopApi - factory interface
 * @export
 */
export const DopApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DopApiFp(configuration)
    return {
        /**
         * This for staff creates a new intent.
         * @summary Staff create intent
         * @param {IntentRequest} intentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntent(intentRequest: IntentRequest, options?: any): AxiosPromise<LodgingResult> {
            return localVarFp.createIntent(intentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This creates new market branch.
         * @summary Create branch
         * @param {BranchRequest} branchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMarketBranch(branchRequest: BranchRequest, options?: any): AxiosPromise<MarketBranch> {
            return localVarFp.createMarketBranch(branchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This disable the market branch.
         * @summary Disable branch
         * @param {string} branchId Branch ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableMarketBranch(branchId: string, options?: any): AxiosPromise<void> {
            return localVarFp.disableMarketBranch(branchId, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation disable a specified staff.
         * @summary Disable staff
         * @param {string} staffId Staff ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableStaff(staffId: string, options?: any): AxiosPromise<void> {
            return localVarFp.disableStaff(staffId, options).then((request) => request(axios, basePath));
        },
        /**
         * This enable the market branch.
         * @summary Enable branch
         * @param {string} branchId Branch ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableMarketBranch(branchId: string, options?: any): AxiosPromise<void> {
            return localVarFp.enableMarketBranch(branchId, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation enable a specified staff.
         * @summary Enable staff
         * @param {string} staffId Staff ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableStaff(staffId: string, options?: any): AxiosPromise<void> {
            return localVarFp.enableStaff(staffId, options).then((request) => request(axios, basePath));
        },
        /**
         * This retrieves bnpl transaction list for market staff. 
         * @summary BNPL transaction listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBnplOrders(options?: any): AxiosPromise<GetBnplOrders200Response> {
            return localVarFp.getBnplOrders(options).then((request) => request(axios, basePath));
        },
        /**
         * This retrieves BNPL statistics for staff 
         * @summary Get BNPL statistics for staff
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBnplStatisticsForStaff(options?: any): AxiosPromise<GetBnplStatisticsForStaff200Response> {
            return localVarFp.getBnplStatisticsForStaff(options).then((request) => request(axios, basePath));
        },
        /**
         * This retrieve branch detail. 
         * @summary Get branch detail
         * @param {string} branchId Branch ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranchDetail(branchId: string, options?: any): AxiosPromise<MarketBranch> {
            return localVarFp.getBranchDetail(branchId, options).then((request) => request(axios, basePath));
        },
        /**
         * This retrieves market branch list. 
         * @summary Get branch list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranchList(options?: any): AxiosPromise<GetBranchList200Response> {
            return localVarFp.getBranchList(options).then((request) => request(axios, basePath));
        },
        /**
         * This retrieves market branch list for staff 
         * @summary Get branch list for staff
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranchListForStaff(options?: any): AxiosPromise<GetBranchList200Response> {
            return localVarFp.getBranchListForStaff(options).then((request) => request(axios, basePath));
        },
        /**
         * This retrieves market staff detail for staff 
         * @summary Get staff detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailForStaff(options?: any): AxiosPromise<MarketStaff> {
            return localVarFp.getDetailForStaff(options).then((request) => request(axios, basePath));
        },
        /**
         * This retrieves staff invitation list. 
         * @summary Get staff invitation list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaffInvitationList(options?: any): AxiosPromise<GetStaffInvitationList200Response> {
            return localVarFp.getStaffInvitationList(options).then((request) => request(axios, basePath));
        },
        /**
         * This retrieves market staff list. 
         * @summary Get staff list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaffList(options?: any): AxiosPromise<GetStaffList200Response> {
            return localVarFp.getStaffList(options).then((request) => request(axios, basePath));
        },
        /**
         * This send a sms to staff that has a link confirmation.
         * @summary Send staff invitation
         * @param {StaffRequest} staffRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendStaffInvitation(staffRequest: StaffRequest, options?: any): AxiosPromise<void> {
            return localVarFp.sendStaffInvitation(staffRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This updates the market branch information.
         * @summary Update branch
         * @param {string} branchId Branch ID
         * @param {BranchRequest} branchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarketBranch(branchId: string, branchRequest: BranchRequest, options?: any): AxiosPromise<MarketBranch> {
            return localVarFp.updateMarketBranch(branchId, branchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload the document for BNPL order
         * @summary Upload BNPL order document
         * @param {string} orderId Order ID
         * @param {UploadDisbursementRequirementRequest} uploadDisbursementRequirementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBnplOrderDocument(orderId: string, uploadDisbursementRequirementRequest: UploadDisbursementRequirementRequest, options?: any): AxiosPromise<void> {
            return localVarFp.uploadBnplOrderDocument(orderId, uploadDisbursementRequirementRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This confirms an staff phone and code.
         * @summary Verify staff
         * @param {string} code Confirmation code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyStaff(code: string, options?: any): AxiosPromise<void> {
            return localVarFp.verifyStaff(code, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DopApi - interface
 * @export
 * @interface DopApi
 */
export interface DopApiInterface {
    /**
     * This for staff creates a new intent.
     * @summary Staff create intent
     * @param {IntentRequest} intentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApiInterface
     */
    createIntent(intentRequest: IntentRequest, options?: AxiosRequestConfig): AxiosPromise<LodgingResult>;

    /**
     * This creates new market branch.
     * @summary Create branch
     * @param {BranchRequest} branchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApiInterface
     */
    createMarketBranch(branchRequest: BranchRequest, options?: AxiosRequestConfig): AxiosPromise<MarketBranch>;

    /**
     * This disable the market branch.
     * @summary Disable branch
     * @param {string} branchId Branch ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApiInterface
     */
    disableMarketBranch(branchId: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * This operation disable a specified staff.
     * @summary Disable staff
     * @param {string} staffId Staff ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApiInterface
     */
    disableStaff(staffId: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * This enable the market branch.
     * @summary Enable branch
     * @param {string} branchId Branch ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApiInterface
     */
    enableMarketBranch(branchId: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * This operation enable a specified staff.
     * @summary Enable staff
     * @param {string} staffId Staff ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApiInterface
     */
    enableStaff(staffId: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * This retrieves bnpl transaction list for market staff. 
     * @summary BNPL transaction listing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApiInterface
     */
    getBnplOrders(options?: AxiosRequestConfig): AxiosPromise<GetBnplOrders200Response>;

    /**
     * This retrieves BNPL statistics for staff 
     * @summary Get BNPL statistics for staff
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApiInterface
     */
    getBnplStatisticsForStaff(options?: AxiosRequestConfig): AxiosPromise<GetBnplStatisticsForStaff200Response>;

    /**
     * This retrieve branch detail. 
     * @summary Get branch detail
     * @param {string} branchId Branch ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApiInterface
     */
    getBranchDetail(branchId: string, options?: AxiosRequestConfig): AxiosPromise<MarketBranch>;

    /**
     * This retrieves market branch list. 
     * @summary Get branch list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApiInterface
     */
    getBranchList(options?: AxiosRequestConfig): AxiosPromise<GetBranchList200Response>;

    /**
     * This retrieves market branch list for staff 
     * @summary Get branch list for staff
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApiInterface
     */
    getBranchListForStaff(options?: AxiosRequestConfig): AxiosPromise<GetBranchList200Response>;

    /**
     * This retrieves market staff detail for staff 
     * @summary Get staff detail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApiInterface
     */
    getDetailForStaff(options?: AxiosRequestConfig): AxiosPromise<MarketStaff>;

    /**
     * This retrieves staff invitation list. 
     * @summary Get staff invitation list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApiInterface
     */
    getStaffInvitationList(options?: AxiosRequestConfig): AxiosPromise<GetStaffInvitationList200Response>;

    /**
     * This retrieves market staff list. 
     * @summary Get staff list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApiInterface
     */
    getStaffList(options?: AxiosRequestConfig): AxiosPromise<GetStaffList200Response>;

    /**
     * This send a sms to staff that has a link confirmation.
     * @summary Send staff invitation
     * @param {StaffRequest} staffRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApiInterface
     */
    sendStaffInvitation(staffRequest: StaffRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * This updates the market branch information.
     * @summary Update branch
     * @param {string} branchId Branch ID
     * @param {BranchRequest} branchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApiInterface
     */
    updateMarketBranch(branchId: string, branchRequest: BranchRequest, options?: AxiosRequestConfig): AxiosPromise<MarketBranch>;

    /**
     * Upload the document for BNPL order
     * @summary Upload BNPL order document
     * @param {string} orderId Order ID
     * @param {UploadDisbursementRequirementRequest} uploadDisbursementRequirementRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApiInterface
     */
    uploadBnplOrderDocument(orderId: string, uploadDisbursementRequirementRequest: UploadDisbursementRequirementRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * This confirms an staff phone and code.
     * @summary Verify staff
     * @param {string} code Confirmation code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApiInterface
     */
    verifyStaff(code: string, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * DopApi - object-oriented interface
 * @export
 * @class DopApi
 * @extends {BaseAPI}
 */
export class DopApi extends BaseAPI implements DopApiInterface {
    /**
     * This for staff creates a new intent.
     * @summary Staff create intent
     * @param {IntentRequest} intentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApi
     */
    public createIntent(intentRequest: IntentRequest, options?: AxiosRequestConfig) {
        return DopApiFp(this.configuration).createIntent(intentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This creates new market branch.
     * @summary Create branch
     * @param {BranchRequest} branchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApi
     */
    public createMarketBranch(branchRequest: BranchRequest, options?: AxiosRequestConfig) {
        return DopApiFp(this.configuration).createMarketBranch(branchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This disable the market branch.
     * @summary Disable branch
     * @param {string} branchId Branch ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApi
     */
    public disableMarketBranch(branchId: string, options?: AxiosRequestConfig) {
        return DopApiFp(this.configuration).disableMarketBranch(branchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation disable a specified staff.
     * @summary Disable staff
     * @param {string} staffId Staff ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApi
     */
    public disableStaff(staffId: string, options?: AxiosRequestConfig) {
        return DopApiFp(this.configuration).disableStaff(staffId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This enable the market branch.
     * @summary Enable branch
     * @param {string} branchId Branch ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApi
     */
    public enableMarketBranch(branchId: string, options?: AxiosRequestConfig) {
        return DopApiFp(this.configuration).enableMarketBranch(branchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation enable a specified staff.
     * @summary Enable staff
     * @param {string} staffId Staff ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApi
     */
    public enableStaff(staffId: string, options?: AxiosRequestConfig) {
        return DopApiFp(this.configuration).enableStaff(staffId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This retrieves bnpl transaction list for market staff. 
     * @summary BNPL transaction listing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApi
     */
    public getBnplOrders(options?: AxiosRequestConfig) {
        return DopApiFp(this.configuration).getBnplOrders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This retrieves BNPL statistics for staff 
     * @summary Get BNPL statistics for staff
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApi
     */
    public getBnplStatisticsForStaff(options?: AxiosRequestConfig) {
        return DopApiFp(this.configuration).getBnplStatisticsForStaff(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This retrieve branch detail. 
     * @summary Get branch detail
     * @param {string} branchId Branch ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApi
     */
    public getBranchDetail(branchId: string, options?: AxiosRequestConfig) {
        return DopApiFp(this.configuration).getBranchDetail(branchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This retrieves market branch list. 
     * @summary Get branch list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApi
     */
    public getBranchList(options?: AxiosRequestConfig) {
        return DopApiFp(this.configuration).getBranchList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This retrieves market branch list for staff 
     * @summary Get branch list for staff
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApi
     */
    public getBranchListForStaff(options?: AxiosRequestConfig) {
        return DopApiFp(this.configuration).getBranchListForStaff(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This retrieves market staff detail for staff 
     * @summary Get staff detail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApi
     */
    public getDetailForStaff(options?: AxiosRequestConfig) {
        return DopApiFp(this.configuration).getDetailForStaff(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This retrieves staff invitation list. 
     * @summary Get staff invitation list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApi
     */
    public getStaffInvitationList(options?: AxiosRequestConfig) {
        return DopApiFp(this.configuration).getStaffInvitationList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This retrieves market staff list. 
     * @summary Get staff list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApi
     */
    public getStaffList(options?: AxiosRequestConfig) {
        return DopApiFp(this.configuration).getStaffList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This send a sms to staff that has a link confirmation.
     * @summary Send staff invitation
     * @param {StaffRequest} staffRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApi
     */
    public sendStaffInvitation(staffRequest: StaffRequest, options?: AxiosRequestConfig) {
        return DopApiFp(this.configuration).sendStaffInvitation(staffRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This updates the market branch information.
     * @summary Update branch
     * @param {string} branchId Branch ID
     * @param {BranchRequest} branchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApi
     */
    public updateMarketBranch(branchId: string, branchRequest: BranchRequest, options?: AxiosRequestConfig) {
        return DopApiFp(this.configuration).updateMarketBranch(branchId, branchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload the document for BNPL order
     * @summary Upload BNPL order document
     * @param {string} orderId Order ID
     * @param {UploadDisbursementRequirementRequest} uploadDisbursementRequirementRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApi
     */
    public uploadBnplOrderDocument(orderId: string, uploadDisbursementRequirementRequest: UploadDisbursementRequirementRequest, options?: AxiosRequestConfig) {
        return DopApiFp(this.configuration).uploadBnplOrderDocument(orderId, uploadDisbursementRequirementRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This confirms an staff phone and code.
     * @summary Verify staff
     * @param {string} code Confirmation code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DopApi
     */
    public verifyStaff(code: string, options?: AxiosRequestConfig) {
        return DopApiFp(this.configuration).verifyStaff(code, options).then((request) => request(this.axios, this.basePath));
    }
}
